import { call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { get, URL_VARIABLES } from 'services/api'

import { SET_REQUEST_RESULT } from '../reducers/request'


export function* handleGetRequestResult(action) {
  const { token } = action.payload

  const res = yield call(get, {
    url: `/onboarding/result`,
    token,
    source: URL_VARIABLES.ANTIFRAUDE,
  })

  if (res && res.status === 200) {
    yield put({
      type: SET_REQUEST_RESULT,
      payload: res.data,
    })
  } else {
    yield put(push(`/forbidden`))
  }
}

